module.exports = __webpack_public_path__ + "static/media/prop-4-thumb.5a8227de.webp";